import Hero from "../components/Hero";
import "../../css/LandingPage.css";
import ButtonSecondary from "../components/ButtonSecondary";
import Button from "../components/Button";
import HeroImage from "../../assets/images/New2.jpg";
import HelpImage from "../../assets/images/New2.jpg";
import { useNavigate } from "react-router-dom";
import Step1 from "../../assets/images/New-meeting.jpg";
import Step2 from "../../assets/images/New4.jpg";
import Step3 from "../../assets/images/Financial.jpg";
import Step4 from "../../assets/images/NHS small image.jpg";
import Step5 from "../../assets/images/Computer.jpg";



const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <Hero
        title="Financial Planning for you"
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
        lightOverlay={true}
        showButton={true}
      />
      <div className="primary-background-container-content">
        <div className="service-item">
          <div className="service-content">
            <h2 className="light">Who we help</h2>
            <div className="content">
              Are you a time poor medical professional, trying to balance the
              reality of a busy NHS practice, hectic home life and demanding
              private practice.
            </div>
            <div className="content">
              These income streams can have an impact on each other and how best
              to plan and save for the future. Add into the mix the ever
              changing environment of NHS pensions and tax regulation, keeping
              up to date with your financial situation for the future becomes an
              ever increasing challenge.
            </div>
            <h2 className="light">How we can help</h2>
            <div className="content">
              At Foundations Financial Planning, we speak your language, we
              understand that after a three session day in the operating
              theatre, or an over booked clinic, having the energy to process
              complex financial matters is difficult.
            </div>
            <div className="content">
              That’s where Foundations Financial Planning can help, whether you
              are operating in the NHS, Independent Sector, Academia or a mix of
              all three, we make sense of complex financial situations, so you
              can live life on your terms, and build the future you want. Using
              our 5-step lifestyle financial planning process, we create your
              Financial Foundations Plan.
            </div>
          </div>
          <img
            src={HelpImage}
            alt="Financial Planning"
            className="service-image"
          />
        </div>
      </div>
      <div className="primary-background-container">
        <div className="primary-background-container-content">
          <h2>What are you waiting for?</h2>
          <div className="content">
            Ready to take the next step? Let’s bring your vision to life!
            Explore our services and get in touch today for a consultation.
            Together, we’ll make it happen.
          </div>
          <ButtonSecondary
            text="CONTACT US"
            variant="secondary"
            onClick={() => navigate("/contact")}
          />
        </div>
      </div>
      <div className="primary-background-container-content ">
        <h2 className="light">Building your foundations</h2>
        <div className="content">
          When you work with Foundations Financial Planning we will walk you
          through five steps to help you build the future you would like
        </div>

        <div className="primary-background-container-content services-grid">
          <div className="service-item step-item">
            <div className="service-content">
              <img
                src={Step1}
                alt="Step 1"
                className="service-image"
              />

              <div className="subtitle">Step 1</div>
              <div className="content-semibold">Getting to know you</div>
              <div className="content">
                This initial meeting is dedicated to us getting to know each
                other. We will spend time discussing all aspects of your life,
                your objectives, your current situation, what makes you tick and
                what your priorities are for the future.
              </div>
            </div>
          </div>
          <div className="service-item step-item">
            <div className="service-content">
              <img
                src={Step2}
                alt="Step 2"
                className="service-image"
              />

              <div className="subtitle">Step 2</div>
              <div className="content-semibold">The Details</div>
              <div className="content">
                Once agreed we would like to work together, we will send out a
                client agreement to you. This lays out in plain language our
                process and our fees. Then we will have a meeting to get into
                your details, this is where we go through all of your current
                investments, pensions, protection, how you view risk and your
                key objectives for the future. We use this to form the basis of
                your Financial Foundations Plan.
              </div>
            </div>
          </div>
          <div className="service-item step-item">
            <div className="service-content">
              <img
                src={Step3}
                alt="Step 3"
                className="service-image"
              />

              <div className="subtitle">Step 3</div>
              <div className="content-semibold">Creation</div>
              <div className="content">
                We take around 4 weeks to create your own Financial Foundations
                Plan, once completed we will sit down with you and go through
                the Financial Foundations Plan helping you to understand:
                <br />
                A. Where you are at currently
                <br />
                B. Where you are aiming to be
                <br />
                C. What changes (if any) need to be made to get to where you
                want to be
                <br />
                D. Our strategy for achieving those goals
              </div>
            </div>
          </div>
          <div className="service-item step-item">
            <div className="service-content">
              <img
                src={Step4}
                alt="Step 4"
                className="service-image"
              />

              <div className="subtitle">Step 4</div>
              <div className="content-semibold">Action</div>
              <div className="content">
                This is the stage where we put your Financial Foundations Plan
                into action. Everything we discussed during your Financial
                Foundations Plan meeting we will now put into place and set you
                on the course to achieve your objectives.
              </div>
            </div>
          </div>
          <div className="service-item step-item">
            <div className="service-content">
              <img
                src={Step5}
                alt="Step 5"
                className="service-image"
              />

              <div className="subtitle">Step 5</div>
              <div className="content-semibold">Building</div>
              <div className="content">
                We’ve laid the foundations, now each year we will review your
                Financial Foundations Plan, make sure it is building your wealth
                to achieve your objectives and to assure that as your objectives
                and priorities change over time we ensure we build in a manner
                that can accommodate these.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="primary-background-container secondary">
        <div className="primary-background-container-content">
     
          <div className="content">
            You’ve read the steps of how we work with you now, if you’re ready
            to learn more about our company, click the link below.
          </div>
          <ButtonSecondary text="About Us" variant="primary"
            onClick={() => navigate("/about")}
          />
        </div>
      </div>
      <div className="primary-background-container-content">
        <h2 className="light">Client Testimonials</h2>
        <div className="content">
          Don’t take our word for it – here’s what our clients say:
        </div>
        <div className="card-grid">
          <div className="testimonial-card">
            <div className="content-semibold ">Dr G. Mattocks</div>
            <div className="content">Consultant, Whipps Cross Hospital</div>
            <div className="content-small-italic">
              ”I have had the pleasure of working with Morris for the last two
              years and can confidently say that he is a reliable and
              knowledgeable professional. He consistently brings a thoughtful
              and informed approach to his work, and interactions with him are
              always positive and collegial. His calm, friendly manner and
              commitment to high standards make him a valued member of any
              team.”
            </div>
          </div>
          <div className="testimonial-card">
            <div className="content-semibold ">Dr S. Nikolic</div>
            <div className="content">Consultant, The Royal London hospital</div>
            <div className="content-small-italic">
              ”I have no hesitation in recommending Morris to anyone seeking
              financial advice. In the ten years I have known him professionally
              he has always shown the utmost integrity and probity and is
              transparent in all his dealings. In addition, he is unfailingly
              diligent, responsible and entirely trustworthy. I have also come
              to know him personally so can vouch too for his kindness, good
              humour and strength of character.”
            </div>
          </div>
          <div className="testimonial-card">
            <div className="content-semibold ">Mr B. Fear</div>
            <div className="content">UK Country Director</div>
            <div className="content-small-italic">
              ”I have had the genuine pleasure of knowing and working with
              Morris for several years. A deep understanding of the subject
              matter is paired with an enjoyable countenance that makes
              interactions with him invariably; interesting, enjoyable and
              beneficial. I cannot recommend him highly enough.”
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
